import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'

export default class SettingsTaxesForm extends Component {
  static propTypes = {
    hiboutikAccount: PropTypes.string.isRequired,
    onClick: PropTypes.func
  }
  handleSubmitClick = e => {
    this.refs.form.submit()
    if (this.props.onClick) {
      this.props.onClick()
    }
  }
  render() {
    const { hiboutikAccount } = this.props
    return (
      <div>
        <Button color="primary" onClick={this.handleSubmitClick}>
          Modifier les Taux de TVA
        </Button>
        <form
          ref="form"
          method="post"
          action={`https://${hiboutikAccount}.hiboutik.com/#params_tva`}
          target="_blank">
          <input type="hidden" name="show_tab" value="parametres" />
          <input
            type="hidden"
            name="affiche_ma_section_accordion"
            value="params_tva"
          />
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/hiboutikForms/SettingsTaxesForm.js